import { t } from "i18next";
import React from "react";

interface ErrorHandlerProps {
  status: string;
  requiredFields: boolean;
  showSubmit: boolean;
  type: string;
  isProject?: boolean;
  invalidAccess?: boolean;
}

const StatusMessage = ({
  message,
  color,
  top,
}: {
  message: string;
  top: string;
  color: string;
}) => {
  return (
    <span
      style={{
        color: color,
        marginInlineStart: "18px",
        fontSize: "14px",
        width: "160px",
      }}
    >
      {t(message)}
    </span>
  );
};
const StatusHandler = ({
  status,
  requiredFields,
  showSubmit,
  isProject,
  type,
  invalidAccess,
}: ErrorHandlerProps) => {
  const KPIDifference = isProject ? 1200 : 20;

  return (
    <div style={{ marginBottom: "20px" }}>
      {status === "successSubmit" && (
        <StatusMessage
          color="green"
          message={`${isProject ? "Project" : "KPI"} was sent for approval.`}
          top={`${532 - KPIDifference}px`}
        />
      )}
      {status === "successApprove" && (
        <StatusMessage
          color="green"
          top="585px"
          message={`${isProject ? "Project" : "KPI"} was ${
            type === "delete" || type === "del" ? "deleted." : "approved."
          }`}
        />
      )}
      {status === "successReject" && (
        <StatusMessage
          color="green"
          message={`${isProject ? "Project" : "KPI"}${
            type === "delete" || type === "del" ? " deletion" : ""
          } was rejected.`}
          top="585px"
        />
      )}

      {status === "fail" && (
        <StatusMessage
          color="red"
          message="Unknown error"
          top={showSubmit ? `${532 - KPIDifference}px` : "585px"}
        />
      )}
      {status === "failExists" && (
        <StatusMessage
          color="red"
          message={`Edit workflow already exists for this ${
            isProject ? "Project" : "KPI"
          }`}
          top={showSubmit ? `${532 - KPIDifference}px` : "585px"}
        />
      )}

      {status === "successAdmin" && (
        <StatusMessage
          color="green"
          message={`${isProject ? "Project" : "KPI"} was ${
            type === "existing" ? "edited." : "created."
          }`}
          top={`${532 - KPIDifference}px`}
        />
      )}
      {(requiredFields || invalidAccess) && (
        <StatusMessage
          color="red"
          message={
            requiredFields
              ? "Please enter the required fields"
              : "You do not have the required permissions to create a KPI under this element"
          }
          top={showSubmit ? `${532 - KPIDifference}px` : "585px"}
        />
      )}
    </div>
  );
};

export default StatusHandler;
